module.exports = __webpack_public_path__ + "static/media/README.b2017b11.md";